import React from 'react';
import CV from '../../assets/cv.pdf';

const CTA = () => {
	return (
		<div className='cta'>
			<a href='https://drive.google.com/file/d/1im3PtSCe3xrA01ea8F6y_i74iiDNdTd5/view?usp=drive_link' className='btn' target='_blank'>
				Show CV
			</a>
			<a href='#contact' className='btn btn-primary'>
				Let's Talk
			</a>
		</div>
	);
};

export default CTA;
